import type { Cell, CellStyle, ITableLayer, ITableLayerProps } from '@/version-types';
import commonPresetTable from './common';
import preset2Table from './preset2';
import preset3Table from './preset3';
import preset4Table from './preset4';
import preset5Table from './preset5';
import preset6Table from './preset6';
import preset7Table from './preset7';
import preset8Table from './preset8';
import testPresetTable from './test';

export interface TablePreset {
    /** 用于埋点统计 */
    id: string;
    preview: string;
    create: () => Omit<ITableLayer<true>, 'top' | 'left'>;
    /**
     * 获取单元格的默认样式, 如果未实现, 则默认样式为allStyleId对应的样式
     * 可以理解为allStyleId无法实现太复杂的默认样式(如preset8), 所以需要通过代码编程的方式来实现
     */
    getCellDefaultStyle?: (
        cell: Cell,
        tableLayerData: Pick<ITableLayerProps, 'allStyleId' | 'styles' | 'presetId'>,
    ) => CellStyle;
    /** 通过预设的样式覆盖已存在表格的样式的功能，仅切换该表格样式下的：单元格颜色、边框 */
    overwriteStyle: (oldTableLayer: ITableLayer) => ITableLayer;
}

const tablePresets: TablePreset[] = [
    commonPresetTable,
    preset2Table,
    preset3Table,
    preset4Table,
    preset5Table,
    preset6Table,
    preset7Table,
    preset8Table,
];

if (process.env.NODE_ENV === 'development') {
    tablePresets.push(testPresetTable);
}

export default tablePresets;
